import React from "react";
import "./App.css";
import Mobile from "./Mobile";
import Desktop from "./Desktop";
import styled from "styled-components";

const DesktopContianer = styled.div`
  display: inherit;
  @media screen and (max-width: 768px) {
    display: none;
  }
`;

const MobileContianer = styled.div`
  display: none;
  @media screen and (max-width: 768px) {
    display: inherit;
  }
`;

function App() {
  return (
    <>
      <DesktopContianer>
        <Desktop />
      </DesktopContianer>
      <MobileContianer>
        <Mobile />
      </MobileContianer>
    </>
  );
}

export default App;
